export const PACKAGE_ASPECT_RATIO = "16 / 9";

/** Style pod panoramiczne zdjęcia — karty, hero, timeline */
export const packageImageSx = {
  width: "100%",
  aspectRatio: PACKAGE_ASPECT_RATIO,
  objectFit: "cover",
  display: "block",
};

export const packageImageFrameSx = {
  width: "100%",
  aspectRatio: PACKAGE_ASPECT_RATIO,
  overflow: "hidden",
  position: "relative",
};
